module.exports = "./img/6eb8f287fb4d04c21c699519ec38bd13.jpg";